<template>
  <ComboboxWithGroups
    :disabled="disabled"
    :item="item"
    :item-text="itemText"
    :item-value="itemValue"
    :items="tariffable"
    :label="label"
    @updated="updated"
    :rules="rules"
    :clearable="clearable"
    :loading="loading"
    :readonly="readonly"
  ></ComboboxWithGroups>
</template>

<script>
import ComboboxWithGroups from "./ComboboxWithGroups";
export default {
  name: "AutocompleteTariffable",
  components: { ComboboxWithGroups },
  props: {
    item: {
      type: [Object, String],
      default: () => ({})
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    itemText: {
      type: String,
      default: "name"
    },
    itemValue: {
      type: String,
      default: "value"
    },
    updated: {
      type: Function,
      default: function() {
        return new Function();
      }
    },
    rules: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tariffPlanId: ""
    };
  },
  computed: {
    tariffable() {
      if (this.tariffPlanId) {
        let components = this.$store.getters[
          "tariffPlanComponentStore/getList"
        ];
        let modifiers = this.$store.getters["tariffPlanModifiersStore/getList"];
        let combinedList = [...components, ...modifiers];
        combinedList = combinedList.filter(
          item => item._tariff_plan.id === this.tariffPlanId
        );
        let groupContacts = combinedList.reduce((ac, val) => {
          val.name = val.name || val.component_name;
          val.group = Object.hasOwn(val, "unit_symbol")
            ? "Component"
            : "Modifier";
          val.value = { id: val.id, group: val.group };
          ac[val.group] ? ac[val.group].push(val) : (ac[val.group] = [val]);
          return ac;
        }, {});
        let tariffableList = Object.keys(groupContacts)
          .sort(function(a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          })
          .reduce((ac, val) => {
            ac.push({ name: val, disabled: true }, ...groupContacts[val]);
            return ac;
          }, []);
        return tariffableList;
      } else {
        let components = this.$store.getters[
          "tariffPlanComponentStore/getList"
        ];
        let modifiers = this.$store.getters["tariffPlanModifiersStore/getList"];
        let combinedList = [...components, ...modifiers];
        let groupContacts = combinedList.reduce((ac, val) => {
          val.name = val.name || val.component_name;
          val.group = Object.hasOwn(val, "unit_symbol")
            ? "Component"
            : "Modifier";
          val.value = { id: val.id, group: val.group };
          ac[val.group] ? ac[val.group].push(val) : (ac[val.group] = [val]);
          return ac;
        }, {});
        return Object.keys(groupContacts)
          .sort(function(a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          })
          .reduce((ac, val) => {
            ac.push({ name: val, disabled: true }, ...groupContacts[val]);
            return ac;
          }, []);
      }
    }
  },
  created() {
    this.$root.$on("updateTariffPlanId", this.updateParentData);
  },
  beforeDestroy() {
    this.$root.$off("updateTariffPlanId", this.updateParentData);
  },
  methods: {
    updateParentData(data) {
      this.tariffPlanId = data;
    }
  },
  watch: {
    tariffPlanId(newVal) {
      this.$emit("updated", newVal);
    }
  }
};
</script>

<style scoped></style>
